<template>
    <div ref="templateRoot" class="pdf-container" style="background-color: #ffffff !important; color: #000000 !important; isolation: isolate;">
        
        <!-- Miejscowość i data -->
        <div class="text-end mb-3">
            <span>{{ contract.issuePlace || '........................' }}</span>, 
            <span>dnia {{ contract.issueDate || '........................' }} r.</span>
        </div>

        <!-- Tytuł dokumentu -->
        <div class="text-center my-3">
            <h4 class="fw-bold m-0 text-uppercase" style="font-size: 14px;">Umowa kupna – sprzedaży pojazdu</h4>
        </div>

        <!-- Strony umowy -->
        <div class="mb-3">
            <div class="fw-bold mb-1">Sprzedający:</div>
            <div class="mb-2 ps-2">
                <div>{{ formatName(contract.seller) }}</div>
                <div v-if="contract.seller?.companyName">Firma: {{ contract.seller.companyName }}</div>
                <div v-if="contract.seller?.idCardSeriesNumber">Seria i numer dowodu osobistego: {{ contract.seller?.idCardSeriesNumber || '........................................' }}</div>
                <div>Adres zameldowania: {{ contract.seller?.street || '' }}, {{ contract.seller?.postalCode || '' }} {{ contract.seller?.city || '' }} ({{ contract.seller?.country || 'Polska' }})</div>
                <div><span v-if="contract.seller?.pesel">PESEL: {{  contract.seller?.pesel || '........................' }}</span> <span v-if="contract.seller?.nip">| NIP: {{ contract.seller.nip }}</span></div>
            </div>

            <div class="fw-bold mb-1">Kupujący:</div>
            <div class="ps-2">
                <div>{{ formatName(contract.buyer) }}</div>
                <div v-if="contract.buyer?.companyName">Firma: {{ contract.buyer.companyName }}</div>
                <div v-if="contract.buyer?.idCardSeriesNumber">Seria i numer dowodu osobistego: {{ contract.buyer?.idCardSeriesNumber || '........................................' }}</div>
                <div>Adres zameldowania: {{ contract.buyer?.street || '' }}, {{ contract.buyer?.postalCode || '' }} {{ contract.buyer?.city || '' }} ({{ contract.buyer?.country || 'Polska' }})</div>
                <div><span v-if="contract.buyer?.pesel">PESEL: {{ contract.buyer?.pesel || '........................' }}</span> <span v-if="contract.buyer?.nip">| NIP: {{ contract.buyer.nip }}</span></div>
            </div>
        </div>

        <!-- § 1 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 1</div>
            <div>Przedmiotem niniejszej umowy jest pojazd:</div>
            <table class="table custom-table mt-1 mb-2 no-border">
                <tbody>
                    <tr >
                        <td style="width: 35%;">Marka / Model</td>
                        <td ><strong>{{ contract.car?.make || '' }} {{ contract.car?.model || '---' }}</strong></td>
                    </tr>
                    <tr >
                        <td >Nr rejestracyjny</td>
                        <td >{{ contract.car?.registrationPlate || '---' }}</td>
                    </tr>
                    <tr>
                        <td>Nr VIN nadwozia/podwozia (ramy)</td>
                        <td><strong>{{ contract.car?.vin || '---' }}</strong></td>
                    </tr>
                    <tr>
                        <td>Rok produkcji</td>
                        <td>{{ contract.car?.productionYear || '---' }}</td>
                    </tr>
                    <tr>
                        <td>Przebieg</td>
                        <td>{{ contract.car?.mileage ? contract.car.mileage + ' km' : '---' }}</td>
                    </tr>
                    <tr>
                        <td>Uwagi / Stan / Dodatki</td>
                        <td>{{ contract.car?.additionalInfo || contract.vehicleStateNotes || 'Brak' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- § 2 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 2</div>
            <div class="text-justify">
                Sprzedający oświadcza, że pojazd będący przedmiotem niniejszej umowy stanowi jego wyłączną własność i jest wolny od wad prawnych oraz obciążeń na rzecz osób trzecich, oraz że nie jest przedmiotem żadnego postępowania ani zabezpieczenia.
            </div>
        </div>

        <!-- § 3 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 3</div>
            <div class="text-justify">
                Strony ustaliły wartość przedmiotu umowy na kwotę: 
                <strong>{{ formatMoney(contract.carPrice) }} {{ contract.carCurrency || 'PLN' }}</strong>
            </div>
            <div class="text-muted fst-italic mt-1">
                Słownie: {{ slownie }}
            </div>
        </div>

        <!-- § 4 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 4</div>
            <div class="text-justify">
                Sprzedający przenosi na rzecz Kupującego własność pojazdu określonego w § 1 niniejszej umowy za kwotę określoną w § 3 niniejszej umowy, której otrzymanie Sprzedający kwituje. Kupujący kwituje jednocześnie odbiór w/w pojazdu.
            </div>
        </div>

        <!-- § 5 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 5</div>
            <div class="text-justify">
                Sprzedający oświadcza, że pojazd nie ma ukrytych wad technicznych, a Kupujący potwierdza, że zna stan techniczny pojazdu, oraz że zapoznał się z dokumentami i oznaczeniami pojazdu i nie wnosi z tego tytułu żadnych zastrzeżeń.
            </div>
        </div>

        <!-- § 6 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 6</div>
            <div class="text-justify">
                Strony ustaliły, że wszelkiego rodzaju koszty transakcji wynikające z realizacji ustaleń niniejszej umowy, a w szczególności opłata podatku od czynności cywilno-prawnych obciążają kupującego.
            </div>
        </div>

        <!-- § 7 -->
        <div class="mb-2">
            <div class="fw-bold text-center mb-1">§ 7</div>
            <div class="text-justify" style="white-space: pre-line;">
                W sprawach nie uregulowanych w niniejszej umowie zastosowanie mają obowiązujące w tym zakresie przepisy Kodeksu Cywilnego.
            </div>
        </div>

        <!-- § 8 -->
        <div class="mb-4">
            <div class="fw-bold text-center mb-1">§ 8</div>
            <div class="text-justify">
                Niniejszą umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.
            </div>
        </div>

        <!-- § 9 -->
        <div class="mb-2" v-if="contract.provisions">
            <div class="fw-bold text-center mb-1">Postanowienia dot. umowy</div>
            <div class="text-justify" style="white-space: pre-line;">
                {{ contract.provisions }}
            </div>
        </div>

        <!-- Podpisy stron -->
        <div class="row pt-4 mt-2 text-center">
            <div class="col-6">
                <div class="border-top border-dark pt-1 mx-5">Sprzedający</div>
            </div>
            <div class="col-6">
                <div class="border-top border-dark pt-1 mx-5">Kupujący</div>
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { kwotaSlownie } from '@/utils/slownie';

 const props = defineProps({
    contract: { type: Object, required: true }
})

const templateRoot = ref(null)
const slownie = computed(() => kwotaSlownie(props.contract.carPrice));

defineExpose({
    element: templateRoot
})

const formatName = (party) => {
    if (!party) return '---'
    if (party.companyName) return party.companyName
    return `${party.firstName || ''} ${party.lastName || ''}`.trim() || '---'
}

const formatMoney = (val) => {
    if (!val && val !== 0) return '0.00'
    return Number(val).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
</script>

<style scoped>
.pdf-container,
.pdf-container * {
    color: #000000 !important;
    box-sizing: border-box;
}

.pdf-container {
    width: 210mm;
    padding: 12mm 15mm;
    font-family: Arial, sans-serif;
    font-size: 10.5px;
    background: #ffffff !important;
    color: #000000 !important;
    line-height: 1.4;
    isolation: isolate;
}

.custom-table {
    font-size: 10px;
    border-color: transparent;
    border:0 none !important;
    background-color: #ffffff;
    border-width: 0;
}

.custom-table td {
    padding: 4px 8px;
    background-color: #ffffff !important;
    color: #000000 !important;
}
</style>